export const REQUEST_HOW_TO_APPLY_INFO = "REQUEST_HOW_TO_APPLY_INFO";
